import { render } from "./SnackBar.vue?vue&type=template&id=421fd174&ts=true"
import script from "./SnackBar.ts?vue&type=script&lang=ts&external"
export * from "./SnackBar.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__